(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';
(function() {
  const Forms = require('./modules/form.js').init;
  const MenuLang = require('./modules/menu-lang.js').init;
  const SupplierSpace = require('./modules/supplier-space.js').init;
  const ProductsList = require('./modules/products-list.js').init;
  const Nav = require('./modules/nav.js').init;
  const NavFooter = require('./modules/nav-footer.js').init;
  const NavProducts = require('./modules/nav-products.js').init;
  const Signup  = require('./modules/signup.js').init;
  const HomeSearchWidget  = require('./modules/home-search-widget.js').init;
  const QuoteCart  = require('./modules/quote-cart.js').init;
  const ButtonToggle  = require('./modules/button-toggle.js').init;
  const ButtonGoToTop = require('./modules/button-go-to-top.js').init;
  const ButtonChat = require('./modules/button-chat.js').init;
  const Videos = require('./modules/video.js').init;

  // If JavaScript
  const collapsible = require('./utils/collapsible.js');
  const Hreels = require('./modules/hreel.js').init;

  // If JavaScript
  document.querySelector('html').className = 'js';

  // If on touch
  window.addEventListener('touchstart', function touched() {
    document.body.classList.add('touch');
    window.removeEventListener('touchstart', touched, false);
  }, false);

  // Main navigation
  Nav();

  // Forms
  Forms();

  // Switch between languages
  MenuLang();


  // Supplier Space
  SupplierSpace();

  // Signup form
  Signup();

  // Horizontal reels (for cards)
  Hreels();

  if (document.querySelector('.main--product-browser')) {
      console.log('product browser loading...');
    ProductsList();
    NavProducts();
  }

  // Footer navigation
  NavFooter();

  //Home home-search-widget
  HomeSearchWidget();

  QuoteCart(document);

  if (document.getElementById("listwish")) {
      const QuoteCartBindEvent  = require('./modules/quote-cart.js').bindCartEvent;
      QuoteCartBindEvent();
  }

  // go to top logic, hide button, and smooth scrolling.
  ButtonGoToTop();

  // display the chat interface from the Olark plugin.
  ButtonChat();

  // Videos
  Videos();
})();

},{"./modules/button-chat.js":2,"./modules/button-go-to-top.js":3,"./modules/button-toggle.js":4,"./modules/form.js":5,"./modules/home-search-widget.js":6,"./modules/hreel.js":7,"./modules/menu-lang.js":8,"./modules/nav-footer.js":10,"./modules/nav-products.js":11,"./modules/nav.js":12,"./modules/products-list.js":14,"./modules/quote-cart.js":15,"./modules/signup.js":16,"./modules/supplier-space.js":18,"./modules/video.js":19,"./utils/collapsible.js":20}],2:[function(require,module,exports){
// @module button chat
const ButtonChat = (() => {
    
    const openchat = () => {
        //the logic to open Olark goes here.
        const olarkChatButton = document.querySelector('.olark-launch-button');
        if (olarkChatButton) {
            olarkChatButton.click();
        }
    }

    const init = () => {
        const chatButton = document.querySelector('.fixed-buttons__button-chat');

        if (!chatButton) return;

        chatButton.addEventListener('click', () => openchat())

        return;
    }

    return {
        init,
    }
})();

module.exports = ButtonChat;

},{}],3:[function(require,module,exports){
// @module  button go to top

const ButtonGoToTop = (() => {
    let lastKnownScrollPosition = 0;
    let ticking = false;

    const scrollTotop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const showOrHideButton = (show, gotToTopButton) =>  {
        gotToTopButton.style.visibility = show ? 'visible' : 'hidden';
        gotToTopButton.style.position = show ? 'unset' : 'absolute'
    }; 

    const init = () => {
        const gotToTopButton = document.querySelector('.fixed-buttons__button-go-to-top');
        const maxHeight = window.innerHeight + (window.innerHeight / 2);

        if (!gotToTopButton) return;

        document.addEventListener('scroll', () => {
            lastKnownScrollPosition = window.scrollY;
            
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    showOrHideButton(lastKnownScrollPosition > maxHeight, gotToTopButton);
                    ticking = false;
                });
            
                ticking = true;
            }
        });

        gotToTopButton.addEventListener('click', () => scrollTotop())
        
        return;
    }

    return {
        init,
    }
})();

module.exports = ButtonGoToTop;
},{}],4:[function(require,module,exports){
// Toggle button module
// @usage:
//   ButtonToggle(document.querySelector('#buttonToggle'), el => {
//     document.querySelector('#moduleSysDmailNewsletter').click();
//   });

const ButtonToggle = (function() {
  const init = (buttonToggle, callBack) => {
    if (buttonToggle) {
      buttonToggle.addEventListener('click', evt => {
        evt.preventDefault();

        buttonToggle.setAttribute(
          'aria-checked',
          buttonToggle.getAttribute('aria-checked') === 'true' ? 'false' : 'true'
        );

        buttonToggle.value = buttonToggle.getAttribute('aria-checked');


        callBack && callBack();

        return;
      });
    }
  };

  return {
    init : init
  };
})();

module.exports = ButtonToggle;

},{}],5:[function(require,module,exports){
// @module form
const Form = (function() {
  const forms = document.getElementsByTagName('form');
  const matches = require('../utils/matches.js');

  const setCustomFileInput = form => {
	  const formElements = form.elements;

    // Loop through forms elements
	  for (let el = 0; el < formElements.length; el++) {
      // Filter file upload
      if (formElements[el].type === 'file'
          && formElements[el].labels[0]) {
        let label = formElements[el].labels[0];

        // Label as button
        label.setAttribute('role', 'button');
        label.classList.add('button--smaller', 'button--reverse');

        // Add a specific class to the parentnode
        label.parentNode.classList.add('form__field--file');

        // Upload interactions
        formElements[el].addEventListener('change', evt => {
          // Put the uploaded file name in a data attribute
          if (evt.target.files.length > 0) {
            label.parentNode.dataset.jsFileinput = evt.target.files[0].name;
          }
        });
      }
    }
  };

  const setOptionalFields = form => {
	  const formElements = form.elements;

	  // Loop through forms elements
	  for (let el = 0; el < formElements.length; el++) {
	    if (!formElements[el].required
		      && formElements[el].type !== 'fieldset'
		      && formElements[el].type !== 'hidden'
		      && formElements[el].type !== 'submit') {
		    let label = formElements[el].labels[0];

        // If label and a match
		    if (label && matches(label.parentNode, '[data-js-form="field"]')) {
		      label.parentNode.classList.add('form__field--optional');
		    }
	    }
	  }

	  return;
  };

  // Initialize method
  const init = () => {
	  // Make sure there's some form in the page
	  if (forms.length > 0) {
	    for (let f = 0; f < forms.length; f++) {
		    setOptionalFields(forms[f]);
		    setCustomFileInput(forms[f]);
	    }
	  }

	  return;
  };

  return {
	  init : init
  };
})();

module.exports = Form;

},{"../utils/matches.js":23}],6:[function(require,module,exports){

// @module nav
const HomeSearchWidget = (function() {
  const homeSearchBox = document.querySelector('[data-js-home-search-box-select=""]');
  const widget = document.querySelector('#home-search-box-select');

  const setSelectedOption = (select) => {
    let options = [].slice.call(select.querySelectorAll('option'));

    [].slice.call(select.querySelectorAll('option')).forEach((opt,idx) => {
      select.selectedIndex === idx ? opt.setAttribute('selected', '') : opt.removeAttribute('selected');
    });

    return;
  };

  const evtCallback = (e) => {
    return setSelectedOption(e.target);
  };

  const init = () => {
    let boxAction;

    if (widget) {
      // Apply the selected state
      setSelectedOption(widget);

      // Selectbox and child select toggle
      widget.addEventListener('change', evt => {
        // Hide everyone first
        [].slice.call(document.querySelectorAll('[data-select-onchange-toggle]'))
          .forEach(el => {
            el.hidden = true;
            el.dataset.selectOnchangeToggle = "false";
            el.setAttribute("data-select-onchange-toggle","false");
            el.removeEventListener('change', evtCallback);
          });

        // Apply the selected state
        setSelectedOption(evt.target);

        // Show the right one
        let selectToShow = document.getElementById("home-search-child-"+evt.target.value);

        if (selectToShow) {
          selectToShow.hidden = false;
          selectToShow.dataset.selectOnchangeToggle = "true";
          selectToShow.setAttribute('aria-live', 'polite');

          // Apply the selected state
          setSelectedOption(selectToShow);
          selectToShow.addEventListener('change', evtCallback);
        }
      });

      // Action box
      boxAction = document.getElementById("home-search-box-action");

      // Apply the selected state
      setSelectedOption(boxAction);
      boxAction.addEventListener('change', evtCallback);

      // Action button
      document.getElementById("home-search-box-button").addEventListener('click', evt => {
        if (boxAction.value == "product-browser") {
          window.location = document.querySelector('[data-select-onchange-toggle="true"]').value;
        } else {
          window.location = boxAction.value;
        }
      });
    }
	  return;
  };

  return {
	  init : init
  };
})();

module.exports = HomeSearchWidget;

},{}],7:[function(require,module,exports){
// @module hreel
const HReel = (function() {
  const setNextButton = (reel, header) => {
    let button = document.createElement('button');

    button.classList.add('button--round','button-opal--reverse');
    button.dataset.jsHreel = 'next';
    button.insertAdjacentHTML('afterbegin', '<svg aria-hidden="true" class="ico-arrowrightbig" height="16" width="16"><use xlink:href="#ico_arrowrightbig"></use></svg><span class="visuallyhidden">Next</span>');

    button.addEventListener('click', evt => {
      reel.scrollLeft += reel.offsetWidth;
    });

    if(header){
      header.insertAdjacentElement('beforeend', button);
    }

    return;
  };

  const setPrevButton = (reel,header) => {
    let button = document.createElement('button');

    button.classList.add('button--round','button-opal--reverse');
    button.dataset.jsHreel = 'prev';
    button.insertAdjacentHTML('afterbegin', '<svg aria-hidden="true" class="ico-arrowrightbig" height="16" width="16"><use xlink:href="#ico_arrowrightbig"></use></svg><span class="visuallyhidden">Prev</span>');

    if (reel.scrollLeft === 0) {
      button.disabled = true;
    }

    button.addEventListener('click', evt => {
      reel.scrollLeft -= reel.offsetWidth;
    });

    if(header){
      header.insertAdjacentElement('beforeend', button);
    }

    return;
  };

  const init = () => {
    const throttle = require('../utils/throttle.js');
    const hreels = [].slice.call(document.querySelectorAll('[data-js-hreel=""]'));

    if (hreels.length > 0) {
      hreels.forEach(hreel => {
        const header = hreel.querySelector('[data-js-hreel="header"]');
        const reel = hreel.querySelector('[data-js-hreel="reel"]');
        const cards = hreel.querySelectorAll('[data-js-hreel="list"] > li');

        // Get the offsetWidth of all cards
        let cardsWidth = 0;

        [].slice.call(hreel.querySelectorAll('[data-js-hreel="list"] > li'))
          .forEach(card => {
            cardsWidth += card.offsetWidth;
          });

        // Offset the reel
        hreel.style.width = `${(document.body.offsetWidth - hreel.getBoundingClientRect().left)}px`;

        // Insert prev/next buttons
        if(reel){
          if (cardsWidth > reel.offsetWidth) {
            setPrevButton(reel, header);
            setNextButton(reel, header);
          }

          // On reel scroll (with throttle)
          reel.addEventListener('scroll', throttle(evt => {
            // Disabled the prev
            if (evt.target.scrollLeft === 0) {
              hreel.querySelector('[data-js-hreel="prev"]').disabled = true;
            } else {
              hreel.querySelector('[data-js-hreel="prev"]').disabled = false;
            }

            // Disabled the next
            if (evt.target.scrollLeft + evt.target.offsetWidth >= evt.target.scrollWidth) {
              hreel.querySelector('[data-js-hreel="next"]').disabled = true;
            } else {
              hreel.querySelector('[data-js-hreel="next"]').disabled = false;
            }
          }, 350));
        }
      });
    }

	  return;
  };

  return {
	  init : init
  };
})();

module.exports = HReel;

},{"../utils/throttle.js":24}],8:[function(require,module,exports){
// @module menu-lang
const MenuLang = (function() {
  const getClosest = require('../utils/get-closest.js');
  const menu = document.getElementById('menulang');

  const setMenuTriggerButton = (menuitems) => {
	  const active = menu.querySelector('[data-js-lang="lang active"]');
	  const buttonIco = '<svg aria-hidden="true" class="ico-chevronfield" height="8" width="5"><use xlink:href="#ico_chevronfield"></use></svg>';
	  const button = `<button aria-expanded="false" class="menu-lang__button" data-js-lang="button">${active.innerHTML}${buttonIco}</button>`;

	  // Replace the active link with the button
	  active.parentNode.innerHTML = button;

	  // Toggle
	  menu.querySelector('[data-js-lang="button"]').addEventListener('click', evt => {
	    let expanded = evt.currentTarget.getAttribute('aria-expanded');

	    if (expanded == 'false') {
		    evt.currentTarget.setAttribute('aria-expanded', 'true');
		    setMenuPanel(menuitems, true);
	    } else {
		    evt.currentTarget.setAttribute('aria-expanded', 'false');
		    setMenuPanel(menuitems, false);
	    }
		
		if( window.innerWidth < 1024 && 
			window.location.href.includes('#cat_') && 
			!(document.getElementById('link_product_fr') || document.getElementById('link_product_en'))
		) {
            document.querySelector('.menu-lang__link').href += window.location.hash;
        }
	  });

    return;
  };

  const setMenuPanel = (menuitems, expanded) => {
	  const notActiveItems = menuitems.filter(item => item.dataset.jsLang !== 'item active');

	  // Onload hide inactive items
	  for (let i = 0; i < notActiveItems.length; i++) {
	    notActiveItems[i].hidden = !expanded;
	  }

	  // Set th menu as expanded
	  if (expanded) {
	    menu.classList.add('menu-lang--expanded');
	  } else {
	    menu.classList.remove('menu-lang--expanded');
	  }

	  return;
  };

  const init = () => {
	  let menuitems;
	  let menutrigger;

	  if (menu) {
	    menuitems = [].slice.call(menu.querySelectorAll('li[data-js-lang*="item"]'));

	    // Set up the panel and the trigger
	    setMenuPanel(menuitems);
	    setMenuTriggerButton(menuitems, false);

	    // Set the height/width of the menu (because of absolute positionning)
	    menutrigger = menu.querySelector('[data-js-lang="button"]');
	    menu.style.height = `${(menutrigger.clientHeight / 16)}rem`;
	    menu.style.width = `${(menutrigger.offsetWidth / 16)}rem`;

	    // When escaped
	    document.addEventListener('keydown', evt => {
		    if ((evt.keyCode || evt.which) === 27
		        && menutrigger.getAttribute('aria-expanded') === 'true') {
		      evt.preventDefault();

		      return menutrigger.click();
		    }

		    return null;
	    });

	    // When clicked outside
	    document.body.addEventListener('click', evt => {
		    if (!getClosest(evt.target, `#${menu.id}`)
		        && menutrigger.getAttribute('aria-expanded') === 'true') {
		      evt.stopPropagation();

		      return menutrigger.click();
		    }

		    return null;
	    });
	  }

	  return;
  };

  return {
	  init : init
  };
})();

module.exports = MenuLang;

},{"../utils/get-closest.js":21}],9:[function(require,module,exports){
// @module menu user
const MenuUser = (function() {

  const init = () => {
    // console.log("ici 11111 aussi");
    const menu = document.querySelector('[data-js-menuuser=""]');
    const collapsible = require('../utils/collapsible.js');

    // console.log(menu);
    if (menu && menu.hidden === false) {
      menu.parentNode.classList.add('is-logged');

      // Large screens
      if (window.matchMedia(`only screen and (min-width: 1024px)`).matches) {
        // console.log("matched aussi");

        // Hide by default on load
        menu.querySelector('[data-js-menuuser="menu"]').hidden = true;

        // Show / hide on click
        collapsible(
          menu.querySelectorAll('[data-js-menuuser="name"]'),
          menu.querySelectorAll('[data-js-menuuser="menu"]'),
          true
        );

        menu.addEventListener('collapse', evt => {
          let parent = evt.detail.targetNode.parentNode;

          if (evt.detail.isExpanded) {
            parent.classList.add('menu-user--expanded');
          } else {
            parent.classList.remove('menu-user--expanded');
          }
        });
      }
    }

    return;
  };

  return {
    init: init
  };
})();

module.exports = MenuUser;

},{"../utils/collapsible.js":20}],10:[function(require,module,exports){
// @module navigation footer
const NavFooter = (function() {
  const collapsible = require('../utils/collapsible.js');
  const nav = document.querySelector('[data-js-navfooter=""]');

  const init = () => {
    if (nav) {
      const triggers = nav.querySelectorAll('[data-js-navfooter="trigger"]');
      const panels = nav.querySelectorAll('[data-js-navfooter="panel"]');

      // Large screens
      if (window.matchMedia(`only screen and (max-width: 1023px)`).matches) {
        // Hide the sublist panels by default on load
        [].slice.call(panels).forEach(panel => panel.hidden = true);

        // Show / hide sublist panels
        collapsible(triggers, panels, true);
      }
    }

	  return;
  };

  return {
	  init : init
  };
})();

module.exports = NavFooter;

},{"../utils/collapsible.js":20}],11:[function(require,module,exports){
// @module product navigation
const NavProducts = (function() {
  const collapsible = require('../utils/collapsible.js');
  const nav = document.querySelector('[data-js-navproducts=""]');

  const setNavProducts = () => {
    nav.addEventListener('collapse', evt => {
      let parent = evt.detail.targetNode.parentNode;
      let back = parent.querySelector('[data-js-navproducts="back"]');
      console.log(back);

      if (window.matchMedia(`only screen and (max-width: 1023px)`).matches) {
        if (evt.detail.isExpanded) {
          back.hidden = false;
          back.onclick = () => evt.detail.triggerNode.click();

          //document.body.style.overflow = 'hidden';

          parent.classList.add('is-within');
          nav.classList.add('has-within');
        } else {
          back.hidden = true;
          back.onclick = null;

          //document.body.style.overflow = null;

          nav.classList.remove('has-within');
          parent.classList.remove('is-within');
        }
      }

      return;
    });

    nav.addEventListener('productfetch', evt => {
      console.log(evt);
    });
  };

  const init = () => {
    if (nav) {
      const triggers = nav.querySelectorAll('[data-js-navproducts="trigger"]');
      const panels = nav.querySelectorAll('[data-js-navproducts="panel"]');

      // Hide the product browser menu on mobile
      if (window.matchMedia(`only screen and (max-width: 1023px)`).matches) {
          console.log(document.querySelector('[data-js-productbrowser="detail"]').dataset.directlink);
         if(document.querySelector('[data-js-productbrowser="detail"]').dataset.directlink == undefined) {
            document.querySelector('[data-js-productbrowser="menu"]').hidden = true;
         }
      }

      [].slice.call(panels).forEach(panel => panel.hidden = true);

      collapsible(triggers, panels);

      setNavProducts();
    }

	  return;
  };

  return {
	  init : init
  };
})();

module.exports = NavProducts;

},{"../utils/collapsible.js":20}],12:[function(require,module,exports){
// @module nav
const Nav = (function() {
  const collapsible = require('../utils/collapsible.js');
  const nav = document.querySelector('[data-js-nav=""]');

  const init = () => {
    if (nav) {
      const triggers = nav.querySelectorAll('[data-js-nav="trigger"]');
      const panels = nav.querySelectorAll('[data-js-nav="panel"]');
      const burger = nav.parentNode.querySelector('[data-js-nav="burger"]');

      // Large screens
      if (window.matchMedia(`only screen and (min-width: 1024px)`).matches) {
        // Hide the sublist panels by default on load
        [].slice.call(panels).forEach(panel => panel.hidden = true);

        // Show / hide sublist panels
        collapsible(triggers, panels, true);

        // Expand only one at a time
        nav.querySelector('[data-js-nav="listalpha"]')
          .addEventListener('collapse', evt => {
            if (evt.detail.isExpanded) {
              let notCurrentTrigger = evt.detail.expandedTriggers.filter(el => el !== evt.detail.triggerNode);
              let notCurrentTarget = evt.detail.expandedTargets.filter(el => el !== evt.detail.targetNode);

              notCurrentTrigger.forEach(el => {
                el.setAttribute('aria-expanded', 'false');
                el.parentNode.classList.remove('is-expanded');
              });

              notCurrentTarget.forEach(el => el.hidden = true);
            }

            return;
          });
      } else { // Smaller screens
        const burgerTrigger = nav.parentNode.querySelectorAll('[data-js-nav="burger"]');
        const burgerTarget = nav.parentNode.querySelectorAll('[data-js-nav=""]');
        const listbeta = nav.querySelector('[data-js-nav="listbeta"]');

        burger.hidden = false;
        nav.hidden = true;

        // Show / hide burger menu
        collapsible(burgerTrigger, burgerTarget, false);

        // Move the second OL in first
        listbeta.parentNode.insertAdjacentElement('afterbegin', listbeta);
      }
    }

	  return;
  };

  return {
	  init : init
  };
})();

module.exports = Nav;

},{"../utils/collapsible.js":20}],13:[function(require,module,exports){
// @module product
const Product = (function() {
  const readMore = (product) => {
    if (product) {
      const desc = product.querySelector('[data-js-product="desc"]');
      const is_too_high =  desc.offsetHeight > 240;
      const cache = product.querySelector('[data-js-product="cache"]');
      const readMore = product.querySelector('[data-js-product="readmore"]');
      let close = document.documentElement.lang === 'fr' ? 'Refermer' : 'Close';
      let open = document.documentElement.lang === 'fr' ? 'Lire plus' : 'Read more';

      console.log(is_too_high, desc.offsetHeight);

      if (is_too_high) {
        readMore.setAttribute('aria-expanded', 'false');
        readMore.hidden = false;
      } else {
        readMore.hidden = true;
        console.log('!!!');
      }

      readMore.addEventListener('click', evt => {
        if (evt.currentTarget.getAttribute('aria-expanded') === 'false') {
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          evt.target.innerHTML = close;

        } else {
          evt.currentTarget.setAttribute('aria-expanded', 'false');
          evt.target.innerHTML = open;
        }
      });
    }

    return;
  };

  const init = () => {
	  return;
  };

  return {
	  init : init,
    readMore : readMore
  };
})();

module.exports = Product;

},{}],14:[function(require,module,exports){
// @module products-list
let currentFragment = window.location.hash;
let fragmentParsing = true;

const ProductsList = (function() {
    const Slideshow = require('../modules/slideshow.js').init;
    const Hreels = require('../modules/hreel.js').init;
    const ReadMore = require('../modules/product.js').readMore;
    const triggerCustomEvent = require('../utils/trigger-custom-event.js');
    const QuoteCart = require('../modules/quote-cart.js').init;
    const QuoteBindCartEvent = require('../modules/quote-cart.js').bindCartEvent;


    const parseFragment = (index) => {
        let isMobile = window.matchMedia(`only screen and (max-width: 1023px)`).matches;

        if ((fragmentParsing) && (currentFragment)) {
            console.log(index);
            currentFragment = currentFragment.replace("cat_", "cat-");

            let linkTarget = currentFragment;
            if (index == 0) {
                let cat = currentFragment.split("_prod_");
                if (cat.length == 2) {
                    linkTarget = cat[index];
                }
            }
            const catLink = document.querySelector(linkTarget + " a");
            if (catLink) {
                //console.log(catLink.dataset);

                setTimeout(function() {
                    document.querySelector('span[data-menuparentcat="' + catLink.dataset.parentCat + '"] button').click();
                }
                    , 500);
                // if mobile we show menu only (no list, no detail) 
                if (isMobile) {
                    document.querySelector('[data-js-productbrowser="menu"]').hidden = false;
                } else {
                    catLink.click();
                }
                if (index == 1) {
                    fragmentParsing = false;
                }
            } else {
                //load first product if no product is selected
                if (!isMobile) {
                    if (document.querySelector("#ajaxMenu ul a")) {
                        document.querySelector("#ajaxMenu ul a").click();
                        fragmentParsing = false;
                    }
                }
            }
        } else {
            //direct link
            //
            if (window.matchMedia(`only screen and (max-width: 1023px)`).matches) {
                document.querySelector('[data-js-productbrowser="detail"]').dataset.directlink = true;

                let back = document.querySelector('[data-js-productbrowser="back"]');
                if (back) {
                    back.hidden = false;
                    registerBackEvent(back);
                }

                document.querySelector('[data-js-productbrowser="menu"]').hidden = false;
                document.querySelector('[data-js-productbrowser="detail"]').hidden = false;

                if(document.querySelector('[data-js-productbrowser="menulist"]')) {
                    document.querySelector('[data-js-productbrowser="menulist"]').hidden = true;
                }
                //document.querySelector('[data-js-productbrowser="detail"]').style.zIndex = Number(window.getComputedStyle(document.querySelector('[data-js-productbrowser="detail"]')).getPropertyValue('z-index') + 1);
                bindMenuClose(document.getElementById('ajaxMenu'));
            }
        }
    };

    const ajaxLink = (container) => {
        const matches = container.querySelectorAll('[data-ajaxlink]');

        if (matches.length) {
            [].forEach.call(matches, function(obj, idx, arr) {
                // do whatever
                obj.addEventListener("click", function(event) {
                    //event.preventDefault();

                    // Remove 'is-active'
                    [].slice.call(arr).forEach(link => {
                        if (link.classList.contains('is-active')) {
                            link.classList.remove('is-active');
                            link.parentNode.parentNode.classList.remove('is-active');
                        }
                    });

                    let httpRequest = new XMLHttpRequest();

                    httpRequest.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            const productBrowser = document.querySelector('[data-js-productbrowser=""]');
                            const menuHeader = document.querySelector('[data-js-productbrowser="menuheader"]');
                            let productDest = document.getElementById(obj.dataset.ajaxdest);
                            let collapsible;
                            let menuClose;
                            let menuList;
                          let back;

                          console.log('MENU HEADER', menuHeader);

                            productDest.innerHTML = this.responseText;
                            productDest.hidden = false;

                            // Add 'is-active'
                            obj.classList.add('is-active');
                            obj.parentNode.parentNode.classList.add('is-active');

                            // Back to the navigation
                            back = productBrowser.querySelector('[data-js-productbrowser="back"]');

                            if (back) {
                                registerBackEvent(back);
                            }

                            // ajaxMenu
                            if (productDest.id === 'ajaxMenu') {
                                // Collapse the product browser menu
                                console.log('111111111');
                                    bindMenuClose(productDest);
                                    /*
                                    menuClose[0].hidden = false;
                                    menuList = productDest.querySelectorAll('[data-js-productbrowser="menulist"]');
                                    if (window.matchMedia(`only screen and (max-width: 1023px)`).matches) {
                                        collapsible = require('../utils/collapsible.js');
                                        collapsible(menuClose, menuList, true);
                                    }
                                    */
                            }

                            // ajaxDetail

                            if (productDest.id === 'ajaxDetail') {
                                const zindexVal = Number(window.getComputedStyle(productDest).getPropertyValue('z-index'));

                                // Product detail
                                // Read more method
                                ReadMore(productDest);

                                // Slideshow
                                Slideshow(productDest.querySelector('[data-js-slideshow=""]'));

                                // Horizontal reels (for cards)
                                Hreels();

                              // On product menu collapse
                              // if (document.querySelector('[data-js-productbrowser="menu"]')) {
                              //   document.querySelector('[data-js-productbrowser="menu"]')
                              //     .addEventListener('collapse', evt => {
                              //       if (!evt.detail.isExpanded) {

                              //       } else {

                              //       }
                              //     });
                              // }

                                // Collapse the product menu
                                if (document.querySelector('[data-js-productbrowser="menuclose"] button')) {
                                    document.querySelector('[data-js-productbrowser="menuclose"] button').click();
                                }

                                QuoteBindCartEvent();
                            }

                            // Recursive call
                            ajaxLink(document.getElementById(obj.dataset.ajaxdest));
                            console.log(obj.dataset.ajaxdest);
                            QuoteCart(document.getElementById(obj.dataset.ajaxdest));
                            updateLangLink();
                            // ajaxMenu
                            if (productDest.id === 'ajaxMenu') {
                                parseFragment(1);
                            }
                            window.scrollTo(0,0);
                        }
                    };

                    httpRequest.open('GET', obj.dataset.ajaxlink, true);
                    httpRequest.send();
                });
            });
        };
    };

    const init = () => {
        ajaxLink(document);
        Slideshow(document.querySelector('[data-js-slideshow=""]'));
        QuoteBindCartEvent();
        parseFragment(0);
        updateLangLink();
        QuoteCart(document);
    };
    const registerBackEvent = (back) => {
        back.hidden = false;
        back.onclick = () => {
          document.querySelector('[data-js-productbrowser="detail"]').style.zIndex = null;
          document.getElementById('ajaxMenu').hidden = true;
        };
    };
    const bindMenuClose = (productDest) => {

        let menuClose = productDest.querySelectorAll('[data-js-productbrowser="menuclose"]');
        if (menuClose.length) {

            menuClose[0].hidden = false;
            let menuList = productDest.querySelectorAll('[data-js-productbrowser="menulist"]');
            if (window.matchMedia(`only screen and (max-width: 1023px)`).matches) {

                let collapsible = require('../utils/collapsible.js');
                collapsible(menuClose, menuList, true);
            }
        }
        return menuClose;
    }

    const updateLangLink = () => {
        if ((document.querySelector('.menu-lang__link[hreflang="fr"]') && (document.getElementById('link_product_fr')))) {
            document.querySelector('.menu-lang__link[hreflang="fr"]').href = document.getElementById('link_product_fr').href;
        }
        if ((document.querySelector('.menu-lang__link[hreflang="en"]') && (document.getElementById('link_product_en')))) {
            document.querySelector('.menu-lang__link[hreflang="en"]').href = document.getElementById('link_product_en').href;
        } 
    };

    return {
        init: init
    };

})();

module.exports = ProductsList;

},{"../modules/hreel.js":7,"../modules/product.js":13,"../modules/quote-cart.js":15,"../modules/slideshow.js":17,"../utils/collapsible.js":20,"../utils/trigger-custom-event.js":25}],15:[function(require,module,exports){
const QuoteCart = (function() {

    const init = (container) => {
        const quoteCount = container.querySelectorAll("[data-ajax-url]");
        // console.log(quoteCount);
        if (quoteCount.length) {
            [].slice.call(quoteCount)
                .forEach(obj => {
                    let carthttpRequest = new XMLHttpRequest();

                    carthttpRequest.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            obj.innerHTML = this.responseText;

                            if (obj.dataset.ajaxCallback != undefined) {
                                eval(obj.dataset.ajaxCallback);
                            }
                        }
                    }
                    carthttpRequest.open('GET', obj.dataset.ajaxUrl, true);
                    carthttpRequest.send();
                });
        }
        return;
    };
    const bindCartEvent = () => {


        [].slice.call(document.querySelectorAll('[data-addtocart]'))
            .forEach(addToCart => {
                if (addToCart) {
                    addToCart.addEventListener("click", function(evt) {

                        let carthttpRequest = new XMLHttpRequest();

                        carthttpRequest.onreadystatechange = function() {
                            if (this.readyState == 4 && this.status == 200) {
                                init(document);
                            }
                        };
                        carthttpRequest.open('GET', addToCart.dataset.addtocart, false);
                        carthttpRequest.send();
                    });
                }
            });
        if (document.getElementById('allwishclick')) {
            var timeout = 1;
            var addAllWish = document.getElementById('allwishclick');
            addAllWish.addEventListener("click", function(evt) {
                console.log(document.querySelectorAll('[data-addtocart]'));
                [].slice.call(document.querySelectorAll('[data-addtocart]'))
                    .forEach(quote => {
                        quote.click();
                    })

            })

        }
    };
    const MenuUser = () => {
        const mnuUser = require('./menu-user.js').init;
        mnuUser();
    }
    const Hreels = () => {
        const Hreels = require('./hreel.js').init;
        Hreels();
    }

    return {
        init: init,
        bindCartEvent: bindCartEvent
    };
})();

module.exports = QuoteCart;

},{"./hreel.js":7,"./menu-user.js":9}],16:[function(require,module,exports){
// @module products-list


const Signup = (function () {



    const init = () => {

        const sfrCountry = document.getElementById('sfrCountry')
        if (sfrCountry) {
            const caOption = document.querySelector('#sfrCountry option[value="CA"]')
            const usOption = document.querySelector('#sfrCountry option[value="US"]')
            sfrCountry.removeChild(usOption)
            sfrCountry.removeChild(caOption)
            sfrCountry.add(usOption, sfrCountry.firstChild)
            sfrCountry.add(caOption, sfrCountry.firstChild)
        }

        /*
         * on click submit form
         */
        const mailingListCheckbox = document.querySelector("#c50 #moduleSysDmailNewsletter");
        //console.log(mailingListCheckbox);
        if (mailingListCheckbox) {
            mailingListCheckbox.addEventListener('click', (evt) => {
                document.getElementById("sfrForm").submit();
            });
        }

        /* 
        Hide Title Select when Other selected
        */
        const sfrTitle = document.getElementById('title');
        if (sfrTitle) {
            sfrTitle.addEventListener('change', (evt) => {
                document.getElementById('titleOther').value = sfrTitle.value;
                if(sfrTitle.value == 'other'){
                    document.getElementById('titleOther').hidden = false;
                } else {
                    document.getElementById('titleOther').hidden = true;
                }
            });

        };

    }
        return {
            init: init
        };

})();

module.exports = Signup;

},{}],17:[function(require,module,exports){
// @module slideshow
const Slideshow = (function () {
  const triggerCustomEvent = require("../utils/trigger-custom-event.js");

  const setControls = (slideshow, slides) => {
    const slideshowBody = slideshow.querySelector('[data-js-slideshow="body"]');
    let controls = document.createElement("ul");

    controls.classList.add("slideshow__controls");
    controls.dataset.jsSlideshow = "controls";
    controls.setAttribute("aria-label", "gallery controls");
    controls.innerHTML = `
    <li class="slideshow__prev">
      <button class="button--round button-opal--reverse" data-js-slideshow="prev" aria-label="previous" disabled="">
        <svg aria-hidden="true" class="ico-arrowrightbig" height="12" width="12"><use xlink:href="#ico_arrowrightbig"></use></svg>
      </button>
    </li>
    <li class="slideshow__next">
      <button class="button--round button-opal--reverse" data-js-slideshow="next" aria-label="next">
        <svg aria-hidden="true" class="ico-arrowrightbig" height="12" width="12"><use xlink:href="#ico_arrowrightbig"></use></svg>
      </button>
    </li>
    `;

    // Onclick controls
    controls.addEventListener("click", (evt) => {
      const thumbnails = [].slice.call(
        slideshow.querySelectorAll('[data-js-slideshow="thumbnail"]'),
      );
      const current = thumbnails.find((thumbnail) =>
        thumbnail.classList.contains("is-current"),
      );
      const currentIndex = thumbnails.indexOf(current);

      let button = evt.target.closest("button").dataset.jsSlideshow;
      let nextThumbnail = thumbnails[currentIndex + 1];
      let prevThumbnail = thumbnails[currentIndex - 1];

      if (button === "next" && nextThumbnail) {
        nextThumbnail.click();
      } else if (button === "prev" && prevThumbnail) {
        prevThumbnail.click();
      } else {
        thumbnails[0].click();
      }
    });

    // Insert controls in the page
    slideshow
      .querySelector('[data-js-slideshow="frame"]')
      .insertAdjacentElement("beforeend", controls);

    return;
  };

  const setZoomIn = (slideshow) => {
    const icoZoom =
      '<svg aria-hidden="true" class="ico-zoomin" height="16" width="16"><use xlink:href="#ico_zoomin"></use></svg>';
    let buttonZoom = slideshow.querySelector('[data-js-slideshow="zoomin"]');
    let buttonClose = slideshow.querySelector(
      '[data-js-slideshow="zoomclose"]',
    );

    const buttonMin = slideshow.querySelector('[data-js-slideshow="zoomin-moins"]');
    const buttonPlus = slideshow.querySelector('[data-js-slideshow="zoomin-plus"]');
    buttonZoom.hidden = false;
    buttonZoom.addEventListener("click", (evt) => {
      buttonZoom.classList.remove("button--round");
      buttonZoom.classList.add("slideshow__zoomin--open");
      buttonMin.classList.add("slideshow__zoomin-moins--visible");
      buttonPlus.classList.add("slideshow__zoomin-plus--visible");
      document.body.style.overflow = "hidden";
      document.querySelector("[data-js-overlay]").hidden = false;
      document.querySelector('[data-js-slideshow="header"]').hidden = false;
      slideshow.classList.toggle("slideshow--zoomin", true);
      slideshow
      .querySelector('.is-current[data-js-slideshow="thumbnail"]')
      .click();
      slideshow.setAttribute("tabindex", "0");
      slideshow.focus();
      buttonZoom.disabled = true;
    });
    
    buttonClose.addEventListener("click", (evt) => {
      buttonZoom.disabled = false;
      buttonZoom.classList.add("button--round");
      buttonZoom.classList.remove("slideshow__zoomin--open");
      buttonMin.classList.remove("slideshow__zoomin-moins--visible");
      buttonPlus.classList.remove("slideshow__zoomin-plus--visible");
      document.body.style.overflow = null;
      document.querySelector("[data-js-overlay]").hidden = true;
      document.querySelector('[data-js-slideshow="header"]').hidden = true;
      slideshow.classList.toggle("slideshow--zoomin", false);
      slideshow
        .querySelector('.is-current[data-js-slideshow="thumbnail"]')
        .click();
      slideshow.removeAttribute("tabindex");
      buttonZoom.focus();
    });

    

    document
      .querySelector('[data-js-slideshow="frame"]')
      .insertAdjacentElement("beforeend", buttonZoom);

    return;
  };

// ZOOM In & Out dans le Slideshow 

  const setZoomControls = (slideshow) => {
    let zoomLevel = 1;
    const minZoom = 1;
    const maxZoom = 30;

    function applyZoom() {
      // On applique le zoom à l'image courante
      const currentSlide = slideshow.querySelector('[data-js-slideshow="slide"][aria-current="true"]');
      if (!currentSlide) return;
      const img = currentSlide.querySelector('img');
      if (img) {
        img.style.transform = `scale(${zoomLevel})`;
        img.style.transition = "transform 0.2s";
        img.style.transformOrigin = "center center";
        // Reset drag position if zoomLevel == 1
        if (zoomLevel === 1) {
          img.style.cursor = '';
          img.style.left = '';
          img.style.top = '';
          img.style.position = '';
        } else {
          img.style.cursor = 'grab';
          img.style.position = 'relative';
        }
      }
    }

    // Sélectionne les boutons existants dans le DOM
    const buttonMin = slideshow.querySelector('[data-js-slideshow="zoomin-moins"]');
    const buttonPlus = slideshow.querySelector('[data-js-slideshow="zoomin-plus"]');

    if (buttonPlus) {
      buttonPlus.addEventListener("click", () => {
        if (zoomLevel < maxZoom) {
          zoomLevel += 0.2;
          if (zoomLevel > maxZoom) zoomLevel = maxZoom;
          applyZoom();
        }
      });
    }
    if (buttonMin) {
      buttonMin.addEventListener("click", () => {
        if (zoomLevel > minZoom) {
          zoomLevel -= 0.2;
          if (zoomLevel < minZoom) zoomLevel = minZoom;
          applyZoom();
        }
      });
    }

    // Drag & drop pour l'image zoomée
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let imgStartLeft = 0;
    let imgStartTop = 0;

    function getCurrentImg() {
      const currentSlide = slideshow.querySelector('[data-js-slideshow="slide"][aria-current="true"]');
      if (!currentSlide) return null;
      return currentSlide.querySelector('img');
    }

    function onMouseDown(e) {
      const img = getCurrentImg();
      if (!img || zoomLevel === 1) return;
      isDragging = true;
      img.style.cursor = 'grabbing';
      startX = e.clientX;
      startY = e.clientY;
      imgStartLeft = parseInt(img.style.left || 0, 10);
      imgStartTop = parseInt(img.style.top || 0, 10);
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      e.preventDefault();
    }

    function onMouseMove(e) {
      if (!isDragging) return;
      const img = getCurrentImg();
      if (!img) return;
      let dx = e.clientX - startX;
      let dy = e.clientY - startY;
      img.style.left = (imgStartLeft + dx) + 'px';
      img.style.top = (imgStartTop + dy) + 'px';
    }

    function onMouseUp(e) {
      isDragging = false;
      const img = getCurrentImg();
      if (img) img.style.cursor = 'grab';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    // Appliquer les listeners sur chaque slide au zoom
    function setDragListeners() {
      const slides = slideshow.querySelectorAll('[data-js-slideshow="slide"]');
      slides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img) {
          img.removeEventListener('mousedown', onMouseDown);
          img.addEventListener('mousedown', onMouseDown);
        }
      });
    }

    // Mettre à jour les listeners au changement de slide
    slideshow.addEventListener('slide', setDragListeners);
    // Initialiser au chargement
    setDragListeners();

    // Remettre le zoom à 1 lors du changement de slide
    slideshow.addEventListener("slide", () => {
      zoomLevel = 1;
      applyZoom();
    });
  };





  const scrollToSlide = (slideshow, slides, currentIndex) => {
    slideshow
      .querySelector('[data-js-slideshow="body"]')
      .scrollTo(slides[currentIndex].offsetLeft, 0);

    // Set a custom event when slided
    triggerCustomEvent(slides[currentIndex], "slide", {
      notCurrentSlides: slides.filter(
        (slide, idx, arr) => slide !== arr[currentIndex],
      ),
      currentIndex: currentIndex,
    });

    return;
  };

  const setThumbnails = (slideshow, slides) => {
    let thumbnails = document.createElement("ul");
    let buttons;

    thumbnails.classList.add("slideshow__thumbnails");
    thumbnails.dataset.jsSlideshow = "thumbnails";

    slides.forEach((slide, index) => {
      if (slide.querySelector("noscript")) {
        let img = slide.querySelector("noscript").innerHTML;
        let thumbnail = `
        <li>
          <button class="${index === 0 ? "is-current" : ""}" type="button" data-js-slideshow="thumbnail">
            ${img}
          </button>
        </li>
      `;

        thumbnails.insertAdjacentHTML("beforeend", thumbnail);
      }
    });

    // Inject thumbnails in the page
    slideshow.insertAdjacentElement("beforeend", thumbnails);

    // Change slide by clicking on thumbnails
    buttons = [].slice.call(thumbnails.querySelectorAll("button"));
    buttons.forEach((btn, index, arr) => {
      btn.addEventListener("click", (evt) => {
        // Scroll to the offsetLeft of the slide
        scrollToSlide(slideshow, slides, index);

        arr.forEach((btn) => btn.classList.remove("is-current"));
        evt.currentTarget.classList.add("is-current");
      });
    });

    return;
  };

  const init = (slideshow) => {
    if (slideshow) {
      const slideshowIndex = [].slice
        .call(document.querySelectorAll('[data-js-slideshow="body"]'))
        .indexOf(slideshow);
      const slides = [].slice.call(
        slideshow.querySelectorAll('[data-js-slideshow="slide"]'),
      );

      slides.forEach((slide, index) => {
        // Set an id to slide
        slide.id = `s${slideshowIndex}${index}`;

        // Copy the noscript > image
        if (!slide.querySelector("img") && slide.querySelector("noscript")) {
          slide
            .querySelector("figure")
            .insertAdjacentHTML(
              "beforeend",
              slide.querySelector("noscript").innerHTML,
            );
        }

        // Set the first slide as current
        if (index === 0) {
          slide.setAttribute("aria-current", "true");
        }
      });

      //\
      setThumbnails(slideshow, slides);
      setControls(slideshow, slides);
      setZoomIn(slideshow);
      setZoomControls(slideshow);


      // On slide do
      slideshow.addEventListener("slide", (evt) => {
        const prev = slideshow.querySelector('[data-js-slideshow="prev"]');

        evt.detail.notCurrentSlides.forEach((slide) => {
          slide.setAttribute("aria-current", "false");
        });

        evt.target.setAttribute("aria-current", "true");

        if (evt.detail.currentIndex == 0) {
          prev.disabled = true;
        } else {
          prev.disabled = false;
        }

        return;
      });

      // Ajout du contrôle clavier (flèches gauche/droite)
      slideshow.setAttribute("tabindex", "0");
      slideshow.addEventListener("keydown", (evt) => {
        if (evt.key === "ArrowRight" || evt.key === "ArrowLeft") {
          evt.preventDefault();
          const thumbnails = [].slice.call(slideshow.querySelectorAll('[data-js-slideshow="thumbnail"]'));
          const current = thumbnails.find((thumbnail) => thumbnail.classList.contains("is-current"));
          const currentIndex = thumbnails.indexOf(current);
          if (evt.key === "ArrowRight" && currentIndex < thumbnails.length - 1) {
            thumbnails[currentIndex + 1].click();
          } else if (evt.key === "ArrowLeft" && currentIndex > 0) {
            thumbnails[currentIndex - 1].click();
          }
        }
      });
    }

    return;
  };

  return {
    init: init,
  };
})();

module.exports = Slideshow;

},{"../utils/trigger-custom-event.js":25}],18:[function(require,module,exports){
// @module supplier-space
const SupplierSpace = (function () {
  const supplierTree = document.getElementById("supplierTree");
  const supplierDownloads = document.getElementById("supplierDownloads");
  const ignoreWords = [];
  const matches = require("../utils/matches.js");
  const collapsible = require("../utils/collapsible.js");
  const getTranslate = require("../utils/get-translate.js");
  const translation = getTranslate("translateSupplier");

  // Create an Index with all files
  const setSupplierIndex = (startingNode) => {
    let supplierIndex = [];

    const subfiles = [].slice.call(
      startingNode.querySelectorAll('[data-js-supplier="itemfile"]')
    );

    // Create an object for each file
    // And add it to the supplierIndex array
    subfiles.forEach((file) => {
      supplierIndex.push({
        name: file.dataset.jsName,
        parentName: file.dataset.jsParentname,
        extension: file.dataset.jsExtension,
        showExt: file.dataset.jsShowext,
        url: file.querySelector("[href]").getAttribute("href"),
        modified: file.dataset.jsModified,
      });
    });

    return supplierIndex;
  };

  // Search Form
  const setSupplierSearchForm = (searchIndex) => {
    let searchForm = document.querySelector("#supplierSearch");
    let searchInput = document.querySelector("#supplierSearchInput");

    searchForm.addEventListener("submit", submitHandler);

    function submitHandler(evt) {
      evt.preventDefault();

      supplierDownloads.innerHTML = "";

      return searchDownloads(searchInput.value, searchIndex);
    }

    return;
  };

  // Search Files
  // Greatly Inspired by
  // <https://gomakethings.com/how-to-create-a-search-page-for-a-static-website-with-vanilla-js/>
  const searchDownloads = (query, searchIndex) => {
    let results;
    let regMap;

    if (query !== "*") {
      regMap = query
        .toLowerCase()
        .split(" ")
        .filter(function (word) {
          return word.length && !ignoreWords.includes(word);
        })
        .map(function (word) {
          return new RegExp(word, "i");
        });

      results = searchIndex.reduce(function (results, file, index) {
        // Setup priority count
        let priority = 0;

        // Assign priority
        for (let reg of regMap) {
          if (reg.test(file.extension)) {
            priority += 100;
          }
          let occurences = file.parentName.match(reg);
          if (occurences) {
            priority += occurences.length;
          }
        }

        // If any matches, push to results
        if (priority > 0) {
          results.push({
            priority: priority,
            file: file,
          });
        }

        return results;
      }, []);
    } else {
      results = [];

      searchIndex.forEach((file, index) => {
        results.push({
          file: file,
          priority: index,
        });
      });
    }

    return showDownloads(results);
  };

  // Show the find files
  const showDownloads = (results) => {
    if (results.length > 0) {
      supplierDownloads.innerHTML = "";

      for (let i = 0; i < results.length; i++) {
        let timestamp = new Date(results[i].file.modified * 1000);
        let lastUpdated = new Intl.DateTimeFormat(
          document.documentElement.lang
        ).format(timestamp);

        let result = document.createElement("article");
        let name = `<h2 class="supplier__document-title">${results[i].file.name}</h2>`;
        let tmpParentName =
          results[i].file.showExt !== "false"
            ? results[i].file.showExt
            : results[i].file.parentName;
        let parentName = `<abbr class="pill--extension"><svg aria-hidden="true" class="ico-folder" height="9" width="10"><use xlink:href="#ico_folder_expanded"></use></svg> ${tmpParentName}</abbr>`;

        let date = `<time datetime="${timestamp.toISOString()}">${
          translation.lastUpdated
        }: ${lastUpdated}</time>`;
        let link = `<p><a class="button button--smaller" href="${results[i].file.url}">${translation.download}<span class="visuallyhidden">${results[i].file.name}</span> <svg aria-hidden="true" height="13" width="11"><use xlink:href="#ico_download"></use></svg></a></p>`;
        let tags =
          results[i].file.showExt !== "false"
            ? `<p><a class="tag">${results[i].file.parentName}</p>`
            : "";

        result.classList.add("supplier__document");
        result.innerHTML = `<header class="supplier__document-header">${name} <p>${parentName} ${date}</p>${tags}</header>${link}`;

        supplierDownloads.appendChild(result);
      }
    } else {
      //if we're in the customer space
      if (document.querySelector(".supplier__root.supplier__root--cs")) {
        document.querySelector(
          ".supplier__root.supplier__root--cs"
        ).hidden = true;
      }
      supplierDownloads.innerHTML = `<p><em>${translation.noResults}</em></p>`;
    }

    return;
  };

  const setRootButton = () => {
    const button = supplierTree.querySelector(
      '[data-js-supplier="root"] > button'
    );

    return button.click();
  };

  const setFolderButtons = () => {
    const triggers = [].slice.call(
      supplierTree.querySelectorAll(
        '[data-js-supplier="trigger"],[data-js-supplier="root"]'
      )
    );
    const icoFolder =
      '<svg aria-hidden="true" class="ico-folder" height="14" width="16"><use xlink:href="#ico_folder"></use></svg>';
    const icoArrow =
      '<svg aria-hidden="true" class="ico-chevronfield" height="5" width="8"><use xlink:href="#ico_chevronfield"></use></svg>';

    // Insert a SVG icons in each of them
    triggers.forEach((trigger) => {
      let button = trigger.querySelector("button");
      let folder =
        matches(trigger.nextElementSibling, '[data-js-supplier="folder"]') &&
        trigger.nextElementSibling;
      let hasFolder;

      button.insertAdjacentHTML("afterbegin", icoFolder);
      button.insertAdjacentHTML("afterbegin", icoArrow);

      if (folder) {
        // Test if afolder children  contains at least one itemfolder
        hasFolder = [].slice
          .call(folder.children)
          .some((child) => matches(child, '[data-js-supplier="itemfolder"]'));

        if (hasFolder) {
          trigger.classList.add("for--folder");
        } else {
          trigger.classList.add("for--files");
        }
      }
    });

    supplierTree.addEventListener("collapse", (evt) => {
      if (
        evt.detail.triggerNode.parentNode.id ===
        supplierDownloads.dataset.jsSupplier
      ) {
        // Reset previous states
        triggers.forEach((trigger) => {
          trigger.parentNode.classList.contains("is--active") &&
            trigger.parentNode.classList.remove("is--active");
          trigger
            .querySelector("svg.ico-folder > use")
            .setAttributeNS(
              "http://www.w3.org/1999/xlink",
              "href",
              "#ico_folder"
            );
        });

        // Add .is--active
        evt.detail.triggerNode.parentNode.parentNode.classList.add(
          "is--active"
        );
        // Change the icon folder
        evt.detail.triggerNode
          .querySelector("svg.ico-folder > use")
          .setAttributeNS(
            "http://www.w3.org/1999/xlink",
            "href",
            "#ico_folder_expanded"
          );
      }

      return;
    });

    return;
  };

  const setSupplierTree = (fnCallback) => {
    const selector = {
      file: '[data-js-supplier="itemfile"]',
      folder: '[data-js-supplier="folder"]',
      trigger: '[data-js-supplier="trigger"],[data-js-supplier="root"]',
    };
    const files = [].slice.call(supplierTree.querySelectorAll(selector.file));
    const folders = [].slice.call(
      supplierTree.querySelectorAll(selector.folder)
    );

    // Hide files
    files.forEach((file) => {
      file.hidden = true;
    });

    // Hide folders by default
    folders.forEach((folder) => {
      folder.hidden = true;
    });

    // Uncollapse / Collapse folders
    collapsible(
      document.querySelectorAll(selector.trigger),
      document.querySelectorAll(selector.folder)
    );
    console.log(document.querySelector('[data-js-supplier="root"]').outerHTML);

    // Search the files of the collapsible targetnode
    supplierTree.addEventListener("collapse", (evt) => {
      searchDownloads("*", setSupplierIndex(evt.detail.targetNode.parentNode));

      // Make a link between the selected folder and the downloads section
      supplierDownloads.dataset.jsSupplier =
        evt.detail.triggerNode.parentNode.id;
    });

    return fnCallback();
  };

  const resizeDiv = () => {
    let tree = document.querySelectorAll("#supplierTree.fal-securedownload");
    console.log(tree);
    tree.forEach((element) => {
      element.style.height =
        window.innerHeight - element.getBoundingClientRect().top + "px";
      console.log(element);
    });
  };

  const init = () => {
    if (supplierTree && supplierDownloads) {
      // Init search form
      setSupplierSearchForm(setSupplierIndex(supplierTree));

      setSupplierTree(() => {
        // Init the root button
        setRootButton();
        // Init the supplier space tree
        setFolderButtons();
      });
    }
    resizeDiv();

    return;
  };

  return {
    init: init,
  };
})();

module.exports = SupplierSpace;

},{"../utils/collapsible.js":20,"../utils/get-translate.js":22,"../utils/matches.js":23}],19:[function(require,module,exports){
// @module video
const Video = (function() {
    const videoCards = [].slice.call(document.querySelectorAll('[data-js-video-zoom=""]'));

    const setVideoZoomOnCard = videos => {
        videos.forEach(v => {
            let show = v.querySelector('[data-js-video-zoom="show"]');
            let close = v.querySelector('[data-js-video-zoom="close"]');
            let overlay = document.querySelector('[data-js-overlay]');
            let video = v.querySelector('video') || v.querySelector('iframe');

            if (video) {
                let videoPoster= video.getAttribute("tsposter") || video.getAttribute("poster");
                show.style.backgroundImage = `url(${videoPoster})`;

                video.setAttribute('normalposter', video.getAttribute('poster'));

                // Show
                show.hidden = false;
                show.addEventListener('click', evt => {
                    evt.currentTarget.hidden = true;

                    close.hidden = false;
                    document.body.style.overflow = 'hidden';
                    overlay.hidden = false;

                    if (v.querySelector('iframe')) {
                        video.parentNode.classList.add('iframe');
                    }

                    v.classList.toggle('video-zoom--zoomin', true);
                    v.setAttribute('tabindex', '0');
                    video.setAttribute('poster', video.getAttribute('modalposter'));
                    v.focus();
                });


                // Hide
                close.addEventListener('click', evt => {
                    evt.currentTarget.hidden = true;

                    show.hidden = false;
                    show.focus();

                    document.body.style.overflow = null;
                    overlay.hidden = true;

                    if (v.querySelector('iframe')) {
                        video.parentNode.classList.remove('iframe');
                    }

                    v.classList.toggle('video-zoom--zoomin', false);
                    v.removeAttribute('tabindex');
                    video.setAttribute('poster', video.getAttribute('normalposter'));

                    if (v.querySelector('video')) {
                        video.pause();
                    }
                });

                overlay.addEventListener('click', evt => {
                    close.click();
                    show.focus();
                });
            }
        });
    };

    const init = () => {
        if (videoCards[0]) {
            setVideoZoomOnCard(videoCards);
        }

        return;
    };

    return {
        init: init,
    };
})();

module.exports = Video;

},{}],20:[function(require,module,exports){
// @utility collapsible block
// @param {NodeList|Array} `triggerNodes` Nodes whom triggers the collapsible targets
// @param {NodeList|Array} `targetNodes` Nodes that are collapsible
// @param {Boolean} `closable` If true it closes when clicking outside
// @return {Nodes} Modified nodes
// @usage Collapsible(document.querySelectorAll(myTriggerSelector), document.querySelectorAll(myTargetSelector));
module.exports = (triggerNodes, targetNodes, closable) => {
  const getClosest = require('./get-closest.js');
  const triggerCustomEvent = require('./trigger-custom-event.js');
  const triggers = [].slice.call(
    (triggerNodes || document.querySelectorAll('[data-js-collapsible="trigger"]'))
  );
  const targets = [].slice.call(
    (targetNodes || document.querySelectorAll('[data-js-collapsible="target"]'))
  );

  const setTriggerExpandedClass = triggerNode => {
    const expandedClass = 'is-expanded';

    if (triggerNode.querySelector('button[aria-expanded]').getAttribute('aria-expanded') === 'true') {
      return triggerNode.classList.add(expandedClass);
    } else {
      return triggerNode.classList.contains(expandedClass) &&
        triggerNode.classList.remove(expandedClass);
    }

    return null;
  };

  const setClosableClasses = (triggerButton, target) => {
    triggerButton.dataset.jsClosable = 'trigger';
    target.dataset.jsClosable = 'target';

    return;
  };

  const listenCloseButton = (triggerButton, target) => {
    if (target.querySelector('[data-js-collapsible="close"]')) {

      target.querySelector('[data-js-collapsible="close"]').addEventListener('click', () => {
        triggerButton.click();
        triggerButton.focus();
      });
    }

    return;
  };

  const closeExpandedClosable = () => {
    const expandedClosableTrigger = '[data-js-closable="trigger"][aria-expanded="true"]';
    const expandedClosableTarget = '[data-js-closable="target"]:not([hidden])';

    // When click outside
    /*
    document.body.addEventListener('click', evt => {
      if (!getClosest(evt.target, expandedClosableTrigger)
          && !getClosest(evt.target, expandedClosableTarget)) {
        evt.stopPropagation();

        [].slice.call(document.querySelectorAll(expandedClosableTrigger))
          .forEach(expanded => {
            expanded.click();
          });
      }
    });
    */

    // When escape
    document.body.addEventListener('keydown', evt => {
      if ((evt.keyCode || evt.which) === 27) {
        evt.preventDefault();


        [].slice.call(document.querySelectorAll(expandedClosableTrigger))
          .forEach(expanded => {
            expanded.click();
          });
      }

      return;
    });
  };

  // The number of triggers & targets must be equivalent
  if (triggers.length === targets.length
      && triggers.length > 0) {
    triggers.forEach((trigger, index, arr) => {
      let target = targets[index];

      // Set a button into the declared `trigger`
      trigger.innerHTML = `<button aria-expanded="${!target.hasAttribute('hidden')}" data-js-collapsible="button" type="button">${trigger.innerHTML}</button>`;

      // Set a class if the aria-expanded is at true
      setTriggerExpandedClass(trigger);

      // Listen the click to expand/collapse the `target`
      trigger.querySelector('button').addEventListener('click', evt => {
        let expanded = evt.currentTarget.getAttribute('aria-expanded') === 'true';

        evt.preventDefault();
        evt.currentTarget.setAttribute('aria-expanded', !expanded);
        target.hidden = expanded;

        // Set a class if the aria-expanded is at true
        setTriggerExpandedClass(evt.currentTarget.parentNode);

        // Allow listening when occurs a collapse/uncollapse
        triggerCustomEvent(target, 'collapse', {
          isExpanded: !expanded,
          isClosable: closable,
          triggerNode: evt.currentTarget,
          targetNode: target,
          expandedTriggers: arr.map(trigg => trigg.querySelector('[aria-expanded="true"]'))
            .filter(e => e !== null),
          expandedTargets: targets.filter(e => !e.hasAttribute('hidden'))
        });
      });

      // Only if closable is set to `true`
      if (closable) {
        setClosableClasses(trigger.querySelector('button'), target);
        listenCloseButton(trigger.querySelector('button'), target);
      }
    });

    // Only if closable is set to `true`
    if (closable) {
      closeExpandedClosable();
    }
  }

  return;
};

},{"./get-closest.js":21,"./trigger-custom-event.js":25}],21:[function(require,module,exports){
/**
 * Get the closest matching element up the DOM tree.
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 * @source <https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/>
 */
module.exports = (elem, selector) => {
    const matches = require('./matches.js');

    // Get closest match
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
	if ( matches( elem, selector ) ) return elem;
    }

    return null;
};

},{"./matches.js":23}],22:[function(require,module,exports){
/**
 * Retrieve translations in a script[type=application/json] element
 * @param  {String} id The value of an id attribute
 * @return {Object} Returns an object of key/value translations
 */
module.exports = id => {
  const translation = document.getElementById(id);

  if (translation) {
    if (translation.getAttribute('type') === 'application/json') {
      return JSON.parse(translation.textContent);
    } else {
      return console.error(`The 'script#${id}' element does not exists or does not have the 'type="application/json"' attribute.`);
    }
  }

  return null;
};

},{}],23:[function(require,module,exports){
/**
 * Matches Selector
 * @private
 * @param  {Element} elem Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean} true if the element would be selected by the specified selector string; otherwise, returns false
 * @usage matches(elem, '.my-class');
 * @source <http://youmightnotneedjquery.com/>
 */

module.exports = (elem, selector) => {
    return (elem.matches
            || elem.matchesSelector
            || elem.msMatchesSelector
            || elem.mozMatchesSelector
            || elem.webkitMatchesSelector
            || elem.oMatchesSelector).call(elem, selector);
};

},{}],24:[function(require,module,exports){
// @param {Object} `fnCallback` The function to throttle
// @param {Number} `delay` The setTimeout delay in milisecond
// @return {Object} `fnCallback`
// @usage window.addEventListener('scroll', throttle(function(e) {...}, 50));
// @source <http://www.grafikart.fr/tutoriels/javascript/debounce-throttle-642>
// @about Reduce the amount of times a function can run
module.exports = (fnCallback, delay) => {
    var last;
    var timer;

    return function() {
        var context = this;
        var now = +new Date();
        var args = arguments;

        if (last && now < last + delay) {
            clearTimeout(timer);

            timer = setTimeout(function() {
                last = now;
                fnCallback.apply(context, args);
            }, delay);

        } else {
            last = now;

            fnCallback.apply(context, args);
        }
    };
};

},{}],25:[function(require,module,exports){
// @param {Node} `el` The base element
// @param {String} `eventType` The event type or name
// @param {Object} `eventData` The detail property. Data associated with the event
// @usage triggerCustomEvent(element, 'catdown', [myBigFatData, 'Hello Goodbye!']);
module.exports = (el, eventType, eventData) => {
    let customEvent;

    if (Event) {
        if (typeof Event.prototype.constructor === 'function') {
            customEvent = new Event(eventType, {
                bubbles: true
            });

            customEvent.detail = eventData;
        } else {
            customEvent = document.createEvent('CustomEvent');
            customEvent.initCustomEvent(eventType, true, true, eventData);
        }

        // Dispatch the event.
        return el.dispatchEvent(customEvent);
    }

    return null;
};

},{}]},{},[1]);
